import { type ReactNode } from 'react'
import Divider from '@mui/material/Divider'

/** The five kinds of menu item in design-system/docs/menus.md. Every menu lists them in this order. */
export enum MenuGroup {
  /** The main changes to the record: Run BBC, Refresh Box. */
  Act = 'act',
  /** Opens a related page or view: LCR, View prospect, Sign in as prospect. */
  GoAndShare = 'goAndShare',
  /** Makes a new record from this one: Create new deal. */
  Create = 'create',
  /** Moves the record to another stage: Convert to diligence, Close deal, Move to BD. */
  ChangeState = 'changeState',
  /** Deletes the record. Alone in the last group, in the danger color, behind a confirm. */
  Destroy = 'destroy',
}

const MENU_GROUP_ORDER = [
  MenuGroup.Act,
  MenuGroup.GoAndShare,
  MenuGroup.Create,
  MenuGroup.ChangeState,
  MenuGroup.Destroy,
]

type MenuEntry = ReactNode | false | null | undefined

/**
 * Lays a menu's items out in the fixed group order, split by dividers. Falsy entries drop out
 * and an emptied group takes no divider with it, so a permission-gated item never leaves a
 * stray line. Each item needs its own `key`.
 */
export const joinMenuGroups = (groups: Partial<Record<MenuGroup, MenuEntry[]>>): ReactNode[] =>
  MENU_GROUP_ORDER.map((group) => (groups[group] ?? []).filter(Boolean))
    .filter((items) => items.length > 0)
    .flatMap((items, index) =>
      index === 0 ? items : [<Divider key={`menu-divider-${index}`} />, ...items],
    )
